export const resetTaxCollection = (obj) => ({
  type: "RESET_TAX_COLLECTION",
  obj,
});

export const getTaxCollection = (obj) => ({
  type: "GET_TAX_COLLECTION",
  obj,
});

export const getTaxCollectionSuccess = (data) => ({
  type: "GET_TAX_COLLECTION_SUCCESS",
  data,
});

export const getTaxCollectionFail = (error) => ({
  type: "GET_TAX_COLLECTION_FAIL",
  error,
});

export const createPH10 = (obj) => ({
  type: "CREATE_PH10",
  obj,
});

export const createPH10Success = (data) => ({
  type: "CREATE_PH10_SUCCESS",
  data,
});

export const createPH10Fail = (error) => ({
  type: "CREATE_PH10_FAIL",
  error,
});

export const getTaxCollectionsList = (obj) => ({
  type: "GET_TAX_COLLECTIONS_LIST",
  obj,
});

export const getTaxCollectionsListSuccess = (data) => ({
  type: "GET_TAX_COLLECTIONS_LIST_SUCCESS",
  data,
});

export const getTaxCollectionsListFail = (error) => ({
  type: "GET_TAX_COLLECTIONS_LIST_FAIL",
  error,
});

export const updateTaxCollection = (obj) => ({
  type: "UPDATE_TAX_COLLECTION",
  obj,
});

export const updateTaxCollectionSuccess = (data) => ({
  type: "UPDATE_TAX_COLLECTION_SUCCESS",
  data,
});

export const updateTaxCollectionFail = (error) => ({
  type: "UPDATE_TAX_COLLECTION_FAIL",
  error,
});

export const getYearlyTotalAndPaidTax = (obj) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX",
  obj,
});

export const getYearlyTotalAndPaidTaxSuccess = (data) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX_SUCCESS",
  data,
});

export const getYearlyTotalAndPaidTaxFail = (error) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX_FAIL",
  error,
});

export const getYearlyPaidAndPendingUnits = (obj) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS",
  obj,
});

export const getYearlyPaidAndPendingUnitsSuccess = (data) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS_SUCCESS",
  data,
});

export const getYearlyPaidAndPendingUnitsFail = (error) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS_FAIL",
  error,
});

export const getYearlyTotalAndPaidTaxOfZone = (obj) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_ZONE",
  obj,
});

export const getYearlyTotalAndPaidTaxOfZoneSuccess = (data) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_ZONE_SUCCESS",
  data,
});

export const getYearlyTotalAndPaidTaxOfZoneFail = (error) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX__OF_ZONE_FAIL",
  error,
});

export const getYearlyTotalAndPaidTaxOfCircle = (obj) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_CIRCLE",
  obj,
});

export const getYearlyTotalAndPaidTaxOfCircleSuccess = (data) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX_OF_CIRCLE_SUCCESS",
  data,
});

export const getYearlyTotalAndPaidTaxOfCircleFail = (error) => ({
  type: "GET_YEARLY_TOTAL_AND_PAID_TAX__OF_CIRCLE_FAIL",
  error,
});

export const getYearlyPaidAndPendingUnitsOfZone = (obj) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_ZONE",
  obj,
});

export const getYearlyPaidAndPendingUnitsOfZoneSuccess = (data) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_ZONE_SUCCESS",
  data,
});

export const getYearlyPaidAndPendingUnitsOfZoneFail = (error) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_ZONE_FAIL",
  error,
});
export const getYearlyPaidAndPendingUnitsOfCircle = (obj) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_CIRCLE",
  obj,
});

export const getYearlyPaidAndPendingUnitsOfCircleSuccess = (data) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_CIRCLE_SUCCESS",
  data,
});

export const getYearlyPaidAndPendingUnitsOfCircleFail = (error) => ({
  type: "GET_YEARLY_PAID_AND_PENDING_UNITS_OF_CIRCLE_FAIL",
  error,
});
export const getTotalRegisteredPropertiesOfZone = (obj) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_OF_ZONE",
  obj,
});

export const getTotalRegisteredPropertiesOfZoneSuccess = (data) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_OF_ZONE_SUCCESS",
  data,
});

export const getTotalRegisteredPropertiesOfZoneFail = (error) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_OF_ZONE_FAIL",
  error,
});
export const getTaxOfZone = (obj) => ({
  type: "GET_TAX_OF_ZONE",
  obj,
});

export const getTaxOfZoneSuccess = (data) => ({
  type: "GET_TAX_OF_ZONE_SUCCESS",
  data,
});

export const getTaxOfZoneFail = (error) => ({
  type: "GET_TAX_OF_ZONE_FAIL",
  error,
});
export const getTopPaidUnitsOfZone = (obj) => ({
  type: "GET_TOP_PAID_UNITS_OF_ZONE",
  obj,
});

export const getTopPaidUnitsOfZoneSuccess = (data) => ({
  type: "GET_TOP_PAID_UNITS_OF_ZONE_SUCCESS",
  data,
});

export const getTopPaidUnitsOfZoneFail = (error) => ({
  type: "GET_TOP_PAID_UNITS_OF_ZONE_FAIL",
  error,
});
export const getTopDefaultUnitsOfZone = (obj) => ({
  type: "GET_TOP_DEFAULT_UNITS_OF_ZONE",
  obj,
});

export const getTopDefaultUnitsOfZoneSuccess = (data) => ({
  type: "GET_TOP_DEFAULT_UNITS_OF_ZONE_SUCCESS",
  data,
});

export const getTopDefaultUnitsOfZoneFail = (error) => ({
  type: "GET_TOP_DEFAULT_UNITS_OF_ZONE_FAIL",
  error,
});
export const getTotalRegisteredPropertiesOfCircle = (obj) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_OF_CIRCLE",
  obj,
});

export const getTotalRegisteredPropertiesOfCircleSuccess = (data) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_OF_CIRCLE_SUCCESS",
  data,
});

export const getTotalRegisteredPropertiesOfCircleFail = (error) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_OF_CIRCLE_FAIL",
  error,
});
export const getTaxOfCircle = (obj) => ({
  type: "GET_TAX_OF_CIRCLE",
  obj,
});

export const getTaxOfCircleSuccess = (data) => ({
  type: "GET_TAX_OF_CIRCLE_SUCCESS",
  data,
});

export const getTaxOfCircleFail = (error) => ({
  type: "GET_TAX_OF_CIRCLE_FAIL",
  error,
});
export const getTopPaidUnitsOfCircle = (obj) => ({
  type: "GET_TOP_PAID_UNITS_OF_CIRCLE",
  obj,
});

export const getTopPaidUnitsOfCircleSuccess = (data) => ({
  type: "GET_TOP_PAID_UNITS_OF_CIRCLE_SUCCESS",
  data,
});

export const getTopPaidUnitsOfCircleFail = (error) => ({
  type: "GET_TOP_PAID_UNITS_OF_CIRCLE_FAIL",
  error,
});
export const getTopDefaultUnitsOfCircle = (obj) => ({
  type: "GET_TOP_DEFAULT_UNITS_OF_CIRCLE",
  obj,
});

export const getTopDefaultUnitsOfCircleSuccess = (data) => ({
  type: "GET_TOP_DEFAULT_UNITS_OF_CIRCLE_SUCCESS",
  data,
});

export const getTopDefaultUnitsOfCircleFail = (error) => ({
  type: "GET_TOP_DEFAULT_UNITS_OF_CIRCLE_FAIL",
  error,
});

export const getYearlyPaidTaxTi = (obj) => ({
  type: "GET_YEARLY_PAID_TAX_TI",
  obj,
});

export const getYearlyPaidTaxTiSuccess = (data) => ({
  type: "GET_YEARLY_PAID_TAX_TI_SUCCESS",
  data,
});

export const getYearlyPaidTaxTiFail = (error) => ({
  type: "GET_YEARLY_PAID_TAX_TI_FAIL",
  error,
});

export const getTITotalPendingTax = (obj) => ({
  type: "GET_TI_TOTAL_PENDING_TAX",
  obj,
});

export const getTITotalPendingTaxSuccess = (data) => ({
  type: "GET_TI_TOTAL_PENDING_TAX_SUCCESS",
  data,
});

export const getTITotalPendingTaxFail = (error) => ({
  type: "GET_TI_TOTAL_PENDING_TAX_FAIL",
  error,
});
export const getCircleOrZoneName = (obj) => ({
  type: "GET_CIRCLE_OR_ZONE_NAME",
  obj,
});

export const getCircleOrZoneNameSuccess = (data) => ({
  type: "GET_CIRCLE_OR_ZONE_NAME_SUCCESS",
  data,
});

export const getCircleOrZoneNameFail = (error) => ({
  type: "GET_CIRCLE_OR_ZONE_NAME_FAIL",
  error,
});

export const getTaxDetailsOfPropertyBasedOnYear = (obj) => ({
  type: "GET_TAX_DETAILS_PROPERTY_BASED_ON_YEAR",
  obj,
});

export const getTaxDetailsOfPropertyBasedOnYearSuccess = (data) => ({
  type: "GET_TAX_DETAILS_PROPERTY_BASED_ON_YEAR_SUCCESS",
  data,
});

export const getTaxDetailsOfPropertyBasedOnYearFail = (error) => ({
  type: "GET_TAX_DETAILS_PROPERTY_BASED_ON_YEAR_FAIL",
  error,
});

export const generateChallan = (obj) => ({
  type: "GENERATE_CHALLAN",
  obj,
});

export const generateChallanSuccess = (data) => ({
  type: "GENERATE_CHALLAN_SUCCESS",
  data,
});

export const generateChallanFail = (error) => ({
  type: "GENERATE_CHALLAN_FAIL",
  error,
});

export const getTaxPropertiesList = (obj) => ({
  type: "GET_TAX_PROPERTIES",
  obj,
});

export const getTaxPropertiesSuccess = (data) => ({
  type: "GET_TAX_PROPERTIES_SUCCESS",
  data,
});

export const getTaxPropertiesFail = (error) => ({
  type: "GET_TAX_PROPERTIES_FAIL",
  error,
});
